module.exports = __webpack_public_path__ + "static/img/icon2-8.65c78645.png";